export const ru = {
    'create-by': 'Создать на основе',
    'create-tooltip': 'Вы можете создать до 30 наборов минус-фраз',
    'create-tooltip-disabled': 'Нет прав на создание набора',
    delete: 'Удалить',
    'delete-tooltip': 'Отвяжите набор минус-фраз от всех групп перед удалением',
    'delete-tooltip-disabled': 'Нет прав на удаление набора',
    edit: 'Редактировать',
    'editable-tooltip': 'Нет прав на редактирование набора'
};
